<script setup lang="ts">
import { computed } from "vue";
import ReportState from "@/stores/report/ReportState";

const props = defineProps<{
  mode: "gallery" | "details" | "numbering";
}>();

const currentSize = computed(() => {
  return ReportState.photoSizes[props.mode];
});

const updateSize = (val: number | number[]) => {
  const numVal = Array.isArray(val) ? val[0] : val;
  ReportState.setPhotoSize(props.mode, numVal);
};
</script>

<template>
  <div class="photo-size-control d-flex align-items-center gap-4">
    <el-icon size="20" class="text-dark flex-shrink-0">
      <i class="bi-aspect-ratio"></i>
    </el-icon>
    <el-slider
      :model-value="currentSize"
      :min="0"
      :max="100"
      :step="10"
      :show-tooltip="false"
      class="size-slider"
      @update:model-value="updateSize"
    />
  </div>
</template>

<style lang="scss" scoped>
.photo-size-control {
  min-width: 120px;
  max-width: 140px;
}

.size-slider {
  --el-slider-height: 4px;
  --el-slider-button-size: 14px;
  --el-slider-runway-bg-color: var(--bs-gray-300);
  --el-slider-main-bg-color: var(--bs-dark);
}

:deep(.el-slider__marks-text) {
  display: none;
}

:deep(.el-slider__stop) {
  width: 4px;
  height: 4px;
  background-color: var(--bs-gray-400);
}
</style>
